import React, { useCallback } from 'react';
import { Translation } from 'react-i18next';
import { Typography, Input, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';
import { EyeOutlined } from '@ant-design/icons';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const { Title } = Typography;

const LearningAdminHeaderScreen = ({
  showDetail,
  trackerActions,
  ...props
}) => {
  const showDetailTracker = useCallback(() => {
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_OPEN_PREVIEW
    );
    showDetail();
  }, [showDetail, trackerActions]);

  return (
    <Translation>
      {(t) => (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Title level={2} className='learning-title'>
              {t('learning_admin_title')}
            </Title>
            <Button icon={<EyeOutlined />} onClick={showDetailTracker}>
              {t('learning_admin_preview')}
            </Button>
          </div>
          <Input
            style={{
              width: '20%',
            }}
            placeholder={t('learning_admin_header_search')}
            allowClear
            maxLength={100}
          />
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminHeaderScreen);

Logger.log('silly', `LearningAdminHeaderScreen loaded.`);
